import { Typography } from "@mui/material";

function NoMatchRoute() {
    return (
        <Typography variant="h6">Page Not Found!!</Typography>
    )
  }
  
  export default NoMatchRoute;